import { render, staticRenderFns } from "./Acordeon.vue?vue&type=template&id=c49f73a6"
import script from "./Acordeon.vue?vue&type=script&lang=js"
export * from "./Acordeon.vue?vue&type=script&lang=js"
import style0 from "./Acordeon.vue?vue&type=style&index=0&id=c49f73a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports